// src/store.js
// This is the Redux store configuration

import { applyMiddleware, createStore } from 'redux';
import {thunk} from 'redux-thunk'; // Ensure this is the default import
import rootReducer from './reducers';

// No need for composeWithDevTools or composeEnhancers
const middleware = [thunk]; // Define middleware array correctly

// Create the Redux store with the rootReducer and applyMiddleware
const store = createStore(
    rootReducer,
    applyMiddleware(...middleware) // Apply middleware correctly
);

export default store;
